export default "__VITE_ASSET__DXyyaryv__"